module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBlackItalic.8372ce3e.eot";